import type {SupportedLocale} from '@github-ui/swp-core/lib/utils/localization'

/** Kept in sync with `supportedLocales` in `@github-ui/swp-core` (not exported there). */
const SUPPORTED_LOCALES: readonly SupportedLocale[] = ['de', 'en', 'es', 'fr', 'ja', 'ko', 'pt']

/** Mirrors swp-core `getLocale()`: take the first two chars of a (possibly region-qualified) locale, lowercase, fall back to `en`. */
export function normalizeLocale(locale?: string): SupportedLocale {
  if (!locale) return 'en'
  const short = locale.slice(0, 2).toLowerCase()
  return SUPPORTED_LOCALES.includes(short as SupportedLocale) ? (short as SupportedLocale) : 'en'
}
